// @mui
import Iconify from "../iconify";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";

import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  IconButton,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
// -----------------------------------------

export default function PickemLeaderboardTable(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [leaderboard, setLeaderboard] = useState({ leaderboard: [] });
  const [pickemId, setPickemId] = useState(props.pickemId);
  const [tournamentId, setTournamentId] = useState(null);
  const [leagueId, setLeagueId] = useState(null);
  const [pickem, setPickem] = useState(null);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [openSendEmail, setOpenSendEmail] = useState(false);
  const [load, setLoad] = useState(true);
  const [sendEmailText, setSendEmailText] = useState({
    prize_text_en: "",
    prize_text_lv: "",
    prize_text_et: "",
    prize_text_ru: "",
    prize_text_sk: "",
  });

  useEffect(() => {
    if (pickem && leaderboard.leaderboard) {
      const answers_leaderboard = leaderboard.leaderboard.map(
        (userLeaderboard) => {
          const answers = userLeaderboard.selections.reduce(
            (accum, selection) => {
              const question = pickem.questions.find(
                (item) => item.question_id === selection.question_id
              );
              if (question) {
                if (question.is_tiebreak) {
                  accum.correct_custom_value = question.tiebreak_score;
                  accum.user_custom_value = selection.custom_value;
                }
                const option = question.options.find(
                  (item) => item.option_id === selection.option_id
                );
                if (option) {
                  if (!!option.is_correct) {
                    accum.correct++;
                  }
                  if (!option.is_correct) {
                    accum.incorrect++;
                  }
                }
              }
              return accum;
            },
            {
              correct: 0,
              incorrect: 0,
              correct_custom_value: "",
              user_custom_value: "",
            }
          );
          return { ...userLeaderboard, answers };
        }
      );
      setLeaderboard({ ...leaderboard, leaderboard: answers_leaderboard });
    }
  }, [pickem]);

  const handleAddTrophy = (userId, trophy) => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leaderboard/user/add-trophy?pickem_id=${pickemId}`,
        { user_id: userId, trophy }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleRemoveTrophy = (userId) => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leaderboard/user/remove-trophy?pickem_id=${pickemId}`,
        { user_id: userId }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleOpenSendEmailDialog = () => {
    setSendEmailText({
      prize_text_en: "",
      prize_text_lv: "",
      prize_text_et: "",
      prize_text_ru: "",
      prize_text_sk: "",

      contestname_en: "",
      contestname_ru: "",
      contestname_lv: "",
      contestname_et: "",
      contestname_sk: "",
    });
    setOpenSendEmail(true);
  };

  const handleSendEmail = () => {
    setLoading(true);
    setOpenSendEmail(false);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/send-prize-notifications`,
        {
          ...sendEmailText,
          user_ids: checkedUsers,
          pickem_id: pickemId,
          league_id: leagueId,
          tournament_id: tournamentId,
        }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleCheckUser = (e, user_id) => {
    if (e.target.checked) {
      checkedUsers.push(user_id);
      setCheckedUsers([...checkedUsers]);
    } else {
      const newCheckedUsers = checkedUsers.filter((item) => item !== user_id);
      setCheckedUsers([...newCheckedUsers]);
    }
  };

  const handleChangeEmailFields = (e) => {
    const { id, value } = e.target;

    setSendEmailText((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const getData = async (page) => {
    try {
      const limit = 100;
      if(page === 0) setLoading(true);
        
        setPickemId(pickemId);
        const offset = (page > 1) ? (page - 1) * limit : 0;

        axios
          .get(
            `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-leaderboard/${pickemId}?offset=${offset}&limit=${limit}`
          )
          .then(function (response) {
            if(response.data.leaderboard.length < limit) setLoad(false)
            setLeaderboard((prevState) => ({ 
              ...response.data, 
              leaderboard: [
                ...prevState.leaderboard, 
                ...response.data.leaderboard
              ]
            }));
            axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}`
            ).then(function (response) {
              setPickem(response.data.pickem)
              setLoading(false);
            });
            setLoading(false);
          });

        setLoading(false);
        return true;
    } catch (error) {
      console.log('error', error)
      return false
    }
  }

  return (
    <>
      {checkedUsers.length > 0 && (
        <Card style={{ padding: 20 }}>
          <Box>
            <Typography variant="h5" component="div" sx={{ marginBottom: 2 }}>
              Message
            </Typography>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:paper-plane-outline" />}
              onClick={() => handleOpenSendEmailDialog()}
              sx={{ mr: 2 }}
            >
              Send Prize Email
            </Button>
          </Box>
        </Card>
      )}
      <Card>
        {leaderboard === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <InfiniteScroll
            pageStart={0}
            loadMore={getData}
            hasMore={load}
            loader={
              <div className="loader" key="loader">
                Loading ...
              </div>
            }>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Rank</TableCell>
                    <TableCell>User Id</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Trophy</TableCell>
                    <TableCell>Points</TableCell>
                    {pickem && (
                      <>
                        <TableCell>Correct Answers</TableCell>
                        <TableCell>Incorrect Answers</TableCell>
                        <TableCell>TieBreaker</TableCell>
                      </>
                    )}
                    <TableCell>Prize Email</TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaderboard.leaderboard.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkedUsers.includes(row.user_id)}
                              onChange={(e) => handleCheckUser(e, row.user_id)}
                            />
                          }
                          label=""
                        />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.rank}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.user_id}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.username}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.trophy ?? ""}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.points}
                      </TableCell>
                      {pickem && (
                        <>
                          <TableCell component="th" scope="row">
                            {row.answers?.correct || 0}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.answers?.incorrect || 0}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {`${row.answers?.user_custom_value}(${row.answers?.correct_custom_value})`}
                          </TableCell>
                        </>
                      )}
                      <TableCell component="th" scope="row">
                        {row?.has_prize_email_sent &&
                        row.has_prize_email_sent ? (
                          <Iconify
                            icon={"eva:checkmark-circle-2-outline"}
                            sx={{ color: "green" }}
                          />
                        ) : (
                          <Iconify
                            icon={"eva:close-circle-outline"}
                            sx={{ color: "red" }}
                          />
                        )}
                      </TableCell>
                      <TableCell component="th" scope="row" align="right">
                        <IconButton
                          size="large"
                          color="inherit"
                          onClick={handleOpenMenu}
                          id={row.user_id}
                        >
                          <Iconify icon={"eva:more-vertical-fill"} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </InfiniteScroll>
        )}
      </Card>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => handleAddTrophy(openId, "gold")}>
          <Iconify icon={"eva:star-outline"} sx={{ mr: 1 }} />
          Add Gold Trophy
        </MenuItem>

        <MenuItem onClick={() => handleAddTrophy(openId, "silver")}>
          <Iconify icon={"eva:star-outline"} sx={{ mr: 1 }} />
          Add Silver Trophy
        </MenuItem>
        <MenuItem onClick={() => handleRemoveTrophy(openId)}>
          <Iconify icon={"eva:close-outline"} sx={{ mr: 1 }} />
          Remove Trophy
        </MenuItem>
        {pickemId !== null ? (
          <MenuItem
            onClick={() =>
              navigate(
                `/dashboard/user-selections?pickem_id=${pickemId}&user_id=${openId}`
              )
            }
          >
            <Iconify icon={"eva:eye-outline"} sx={{ mr: 1 }} />
            User Selections
          </MenuItem>
        ) : null}
      </Popover>
      <Dialog
        open={openSendEmail}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Send Email</DialogTitle>
        <DialogContent>
          <TextField
            id="prize_text_en"
            label="Prize Text EN"
            fullWidth
            value={sendEmailText.prize_text_en}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_lv"
            label="Prize Text LV"
            fullWidth
            value={sendEmailText.prize_text_lv}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_ru"
            label="Prize Text RU"
            fullWidth
            value={sendEmailText.prize_text_ru}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_et"
            label="Prize Text ET"
            fullWidth
            value={sendEmailText.prize_text_et}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_sk"
            label="Prize Text SK"
            fullWidth
            value={sendEmailText.prize_text_sk}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_en"
            label="Contest Name EN"
            fullWidth
            value={sendEmailText.contestname_en}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_lv"
            label="Contest Name LV"
            fullWidth
            value={sendEmailText.contestname_lv}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_ru"
            label="Contest Name RU"
            fullWidth
            value={sendEmailText.contestname_ru}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_et"
            label="Contest Name ET"
            fullWidth
            value={sendEmailText.contestname_et}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_sk"
            label="Contest Name SK"
            fullWidth
            value={sendEmailText.contestname_sk}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSendEmail(false)}>Cancel</Button>
          <Button onClick={() => handleSendEmail()} autoFocus>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
